import { getServiceTypeString, formatDateForUI, getStatusColor } from '../../appointment/appointmentFunctions';
import { EditIcon } from '../../buttons/EditIcon.tsx';
import ChatButton from '../../buttons/Chat_button.svg';

export default function StaffAppointmentCard({ 
    svcMsg, 
    serviceTypes, 
    onAcceptAppointment,
    onDeclineAppointment,
    onViewDetails,
    onChat,
    loggedInUser
}) {

    return (
        <div className="lg:hidden w-full">
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                {/* Header with name and status */}
                <div className="flex justify-between items-start mb-4">
                    <div className="flex-1">
                        <p className='font-semibold text-gray-900 text-lg mb-1'>{svcMsg.created_by_user.firstname + ' ' + svcMsg.created_by_user.lastname}</p>
                        <p className='text-sm text-gray-700 font-medium'>{getServiceTypeString(svcMsg.appointment_basic_details.service_type, serviceTypes)}</p>
                    </div>
                    <div className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(svcMsg.nearest_practices[0].practice_appointment_status)}`}>
                        {svcMsg.nearest_practices[0].practice_appointment_status}
                    </div>
                </div>
               
                {/* Appointment Details */}
                <div className="space-y-3 text-sm">
                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium w-20">Date:</span>
                        <span className="text-gray-900 font-medium flex-1 text-right">{formatDateForUI(svcMsg.appointment_basic_details.create_date_time)}</span>
                    </div>
                    <div className="py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium block mb-1">Reason:</span>
                        <p className="text-gray-900 font-medium">{svcMsg.appointment_basic_details.reason}</p>
                    </div>
                    <div className="flex justify-between items-center py-2">
                        <span className="text-gray-700 font-semibold w-20">Urgency:</span>
                        <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                            svcMsg.appointment_basic_details.urgency_type === 'HIGH' ? 'bg-red-100 text-red-800' :
                            svcMsg.appointment_basic_details.urgency_type === 'MEDIUM' ? 'bg-yellow-100 text-yellow-800' :
                            svcMsg.appointment_basic_details.urgency_type === 'LOW' ? 'bg-green-100 text-green-800' :
                            'bg-gray-100 text-gray-800'
                        }`}>
                            {svcMsg.appointment_basic_details.urgency_type || 'NO_URGENCY'}
                        </span>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="mt-6 flex justify-end gap-3">
                    
                    {/* Chat Button */}
                    {svcMsg.nearest_practices[0].practice_appointment_status !== 'SUSPENDED' && (
                        <button
                            onClick={() => onChat(svcMsg, loggedInUser, svcMsg.nearest_practices[0])}
                            className="w-12 h-12 min-w-[48px] min-h-[48px] hover:bg-blue-50 rounded-lg transition-colors flex items-center justify-center"
                            title="Chat"
                        >
                            <img src={ChatButton} alt="Chat" className="w-6 h-6" />
                        </button>
                    )}

                    {/* View Details Button */}
                    <button
                        onClick={() => onViewDetails(svcMsg)}
                        className="w-12 h-12 min-w-[48px] min-h-[48px] bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors flex items-center justify-center"
                        title="View Details"
                    >
                        <EditIcon className='w-6 h-6 text-gray-700 text-gray-600 transform -rotate-90' />
                    </button>
                </div>
            </div>
        </div>
    );
}
